module.exports = __webpack_public_path__ + "media/images/logos/University-College-London-b96de8cca809843da84902897c0991d7.svg";